import { defineComponent as _defineComponent } from 'vue'
import type { IdRef } from './injection';


export default /*#__PURE__*/_defineComponent({
  __name: 'tab-button',
  props: {
    active: { type: Boolean },
    visible: { type: Boolean },
    title: null,
    idRef: null
  },
  emits: ["activate"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'activate', value: IdRef): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    active?: boolean;
    visible?: boolean;
    title?: string;
    idRef: IdRef;
}


//eslint-disable-next-line no-spaced-func


return { __sfc: true,props, emit }
}

})